import { VALUATIONS_OTHER_LABEL } from 'common/constants/valuations';
import { multipleAliases, selectMultipleAliases } from 'pages/Valuations/util/constants';
import { determineDatabaseOption } from 'pages/Valuations/util/percentileOptionsTools';

const getSelectionFromTVT = (cell, value, rowConfig) => {
  const { alias, percentileSelections } = cell;
  if (selectMultipleAliases.includes(alias)) {
    const options = rowConfig.find(({ alias }) => multipleAliases.includes(alias))?.options;
    // if there is only one option it means there isn't a benchmark approach to read multiples from and the only choice is "Other".
    // if the value is the last option, it means it is "Other" (always the last option regardless of the number of multiples available)
    if (options.length === 1 || Number(value) === options.length - 1) return VALUATIONS_OTHER_LABEL;
    return determineDatabaseOption({ value, options }, percentileSelections);
  }
  return '';
};

export default getSelectionFromTVT;
